export default __webpack_public_path__ + "static/svg-symbols-883e853437d7ea85e1b1193f6f2274af.svg";